(() => {
  const match = window.location.pathname.match(/^\/collections\/([^/]+)/);
  const handle = match ? match[1] : '';
  const saleHandles = new Set(['sale', 'sale-damen', 'sale-herren', 'sale-kinder', 'winter-sale', 'outlet']);
  if (!saleHandles.has(handle)) return;

  document.body.classList.add('elk-sale-collection');

  const quickNavigation = document.querySelector('.elk-sale-nav');
  const productTypeKey = 'filter.p.product_type';
  const comparableProductTypes = (url) => url.searchParams.getAll(productTypeKey).sort().join('|');
  const syncQuickNavigation = (url = new URL(window.location.href)) => {
    if (!quickNavigation) return;
    const currentTypes = comparableProductTypes(url);
    quickNavigation.querySelectorAll('.elk-sale-nav__button').forEach((button) => {
      const buttonUrl = new URL(button.href, window.location.origin);
      const isActive = buttonUrl.pathname === url.pathname
        && comparableProductTypes(buttonUrl) === currentTypes;
      button.classList.toggle('is-active', isActive);
      if (isActive) {
        button.setAttribute('aria-current', 'page');
      } else {
        button.removeAttribute('aria-current');
      }
    });
  };

  if (quickNavigation) {
    quickNavigation.addEventListener('click', (event) => {
      const button = event.target.closest('.elk-sale-nav__button');
      if (!button) return;

      const targetUrl = new URL(button.href, window.location.origin);
      if (targetUrl.origin !== window.location.origin || targetUrl.pathname !== window.location.pathname) return;

      const filterForm = document.querySelector('#CollectionFilterForm');
      const productTypeInputs = filterForm
        ? filterForm.querySelectorAll(`input[name="${productTypeKey}"]`)
        : [];
      if (!filterForm || productTypeInputs.length === 0) return;

      event.preventDefault();
      if (targetUrl.href === window.location.href) return;

      const requestedTypes = new Set(targetUrl.searchParams.getAll(productTypeKey));
      let matchedRequestedType = requestedTypes.size === 0;
      productTypeInputs.forEach((input) => {
        input.checked = requestedTypes.has(input.value);
        if (input.checked) matchedRequestedType = true;
      });

      if (!matchedRequestedType) return;

      syncQuickNavigation(targetUrl);
      filterForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });

    window.addEventListener('popstate', () => window.requestAnimationFrame(() => syncQuickNavigation()));
    syncQuickNavigation();
  }

  const colorKeys = new Set(['farbe', 'color', 'colour', 'couleur']);
  const slugify = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const selectedColorFrom = (block) => {
    const link = block.querySelector('a.product-link[href*="variant="], a.sezerium-url[href]');
    if (!link) return '';
    try {
      const url = new URL(link.href, window.location.origin);
      for (const [key, value] of url.searchParams.entries()) {
        if (colorKeys.has(key.toLowerCase())) return slugify(value);
      }
    } catch (_) {}
    return '';
  };

  const filterBlock = (block) => {
    if (!block.matches('.sezerium-product, [data-sezerium-variant]')) return;

    const saleColors = new Set(
      (block.dataset.elkSaleColors || '')
        .split('|')
        .map(slugify)
        .filter(Boolean)
    );
    const selectedColor = selectedColorFrom(block);
    const hasVisibleSalePrice = Boolean(block.querySelector('.price__was, .sezerium-compare-at-price'));
    const keep = saleColors.size > 0 && selectedColor
      ? saleColors.has(selectedColor)
      : hasVisibleSalePrice;

    block.classList.toggle('elk-sale-hidden', !keep);
    block.hidden = !keep;
    block.classList.add('elk-sale-checked');

    block.querySelectorAll('.product-block-options__item[data-option-item]').forEach((swatch) => {
      if (saleColors.size === 0) return;
      const swatchIsOnSale = saleColors.has(slugify(swatch.dataset.optionItem));
      swatch.hidden = !swatchIsOnSale;
      swatch.setAttribute('aria-hidden', swatchIsOnSale ? 'false' : 'true');
    });
  };

  let scheduled = false;
  const filterSaleCards = () => {
    scheduled = false;
    document.querySelectorAll('product-block').forEach(filterBlock);
  };
  const scheduleFilter = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(filterSaleCards);
  };

  scheduleFilter();
  new MutationObserver(scheduleFilter).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scheduleFilter);
})();
